const CURRENCY_FEATURE_KEY = "currency";
export {
  CURRENCY_FEATURE_KEY
};
